<template>
    <div class="stripe-container">
        <div ref="stripecard"></div>
          <button class="btn u-mx-auto" v-on:click="purchase">Purchase</button>
        </div>
</template>

<script>
let stripe = Stripe('pk_test_OjRfDZXa48OcHiYBSwb16aS200A0JJfLQK'),
    elements = stripe.elements(),
    card = undefined;
export default {
    mounted: function () {
        card = elements.create('card');
        card.mount(this.$refs.stripecard);
    },

    methods: {
        purchase(e) {
          let self = this;
            e.preventDefault();
            stripe.createToken(card).then(function(result) {
              if(result.error) {
                console.log(JSON.stringify(result.error));
              } else {
                // Access the token with result.token
                self.$emit('payment', result.token);
                console.log(JSON.stringify(result.token));
              }
               
            });
        }
    }
}
</script>

<style>
/**
 * The CSS shown here will not be introduced in the Quickstart guide, but shows
 * how you can use CSS to style your Element's container.
 */
.StripeElement {
  box-sizing: border-box;

  height: 40px;

  padding: 10px 12px;

  border: 1px solid transparent;
  border-radius: 4px;
  background-color: white;

  box-shadow: 0 1px 3px 0 #e6ebf1;
  -webkit-transition: box-shadow 150ms ease;
  transition: box-shadow 150ms ease;
}

.StripeElement--focus {
  box-shadow: 0 1px 3px 0 #cfd7df;
}

.StripeElement--invalid {
  border-color: #fa755a;
}

.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}
</style>
